import React from "react";
import GNama from "views/pages/forms/Production/Grains/GrainNama/StartGrainNamaForm.js";
import GNamaCultive from "views/pages/forms/Production/Grains/GrainNama/StartGrainNamaFormRelease.js";
import GNamaPLPreparation from "views/pages/forms/Production/Grains/GrainNama/FormForWSP/FormEditDataWSP.js";
import GNamaPLFertilitation from "views/pages/forms/Production/Grains/GrainNama/FormForWSP/FormEditDataFAWSP.js";
import GestionOfCultiveSelectedFieldExtend from "views/pages/forms/Production/Grains/GrainNama/FormForWSP/ModalSelectedFieldsWSP.js";

export default class APIWSP extends React.Component {
  state={
    code:null,
    codeSave:null,
    validatePermitions:true
  }
  initData =async()=>{

  }
    render(){
    const putSaveCode = (code) =>{
      this.setState({codeSave:code})
    }
    const changeValidate=(bolean)=>{
      this.setState({validatePermitions:bolean})
    }
    var gerParam = new URLSearchParams(window.location.search).get("code");
    var gerParamTable = new URLSearchParams(window.location.search).get("table");
    let selectedOptions = [
        { name: 'Información Productor', code: 'IO', table: 'info_producer_g', componentInit: GNamaCultive },
        { name: 'Info del Cultivo', code: 'IC', table: 'info_crops_g', componentInit: GNamaCultive },
        { name: 'Información Cultivos Previos', code: 'PP', table: 'info_prev_g', componentInit: GNamaCultive },
        { name: 'Preparación de Tierra', table: 'production_land_preparation_g', componentInit: GNamaPLPreparation, permission_column: 'production_nama_g' },
        { name: 'Riego', table: 'production_irrigation_g', componentInit: GNamaPLPreparation, permission_column: 'production_nama_g' },
        { name: 'Semilla', table: 'production_seed_g', componentInit: GNamaPLPreparation, permission_column: 'production_nama_g' },
        { name: 'Fertilización/Agroquímicos', table: 'production_fertilizer_g', componentInit: GNamaPLFertilitation, permission_column: 'production_nama_g' },
        { name: 'Siembra', table: 'production_sowing_g', componentInit: GestionOfCultiveSelectedFieldExtend, permission_column: 'production_nama_g' },
        { name: 'Transplante', table: 'production_sowing_transplant', componentInit: GNamaPLPreparation, permission_column: 'production_nama_g' },
        { name: 'Monitoreo Productor', table: 'production_producer_monitoring_g', componentInit: GNamaPLPreparation, permission_column: 'production_nama_g' },
        // { name: 'Clima', table: 'production_producer_monitoring_g', componentInit: GNamaWeather, permission_column: 'production_nama_g' },
        // { name: 'Satélite', table: 'production_info_satelite_dni_code', componentInit: GNamaPLSatelite, permission_column: 'production_nama_g' },
        { name: 'Información de Cosecha', table:'harvest_info_harvest', componentInit:GNamaPLPreparation, permission_column:'harvest_nama_g', code: 'agroquimicos' },
        { name: 'Calibración de Maquinaria', table:'harvest_info_machinery', componentInit:GNamaPLPreparation, permission_column:'harvest_nama_g', code: 'malezas' },
        { name: 'Información de Transporte', table:'harvest_info_transport', componentInit:GNamaPLPreparation, permission_column:'harvest_nama_g', code: 'malezas' },
        { name: 'Información de Post Cosecha', table:'harvest_info_pos_harvest', componentInit:GNamaPLPreparation, permission_column:'harvest_nama_g', code: 'plagas' },

        { name: 'Información de Malezas', table:'hading_info_weeds', componentInit:GNamaPLPreparation, permission_column:'hading_nama_g', code: 'malezas' },
        { name: 'Inventario de Malezas', table:'hading_inventory_weeds', componentInit:GNamaPLPreparation, permission_column:'hading_nama_g', code: 'malezas' },
        { name: 'Información de Plagas', table:'hading_info_plague', componentInit:GNamaPLPreparation, permission_column:'hading_nama_g', code: 'plagas' },
        { name: 'Inventario de Plagas', table:'hading_inventory_plague', componentInit:GNamaPLPreparation, permission_column:'hading_nama_g', code: 'plagas' },
        { name: 'Información de Enfermedades', table:'hading_info_diseases', componentInit:GNamaPLPreparation, permission_column:'hading_nama_g', code: 'enfermedades' },
    ];
    if (gerParamTable==null) {
        selectedOptions = selectedOptions.find((a)=> a.table=='info_producer_g' )
    }else{
        selectedOptions = selectedOptions.find((a)=> a.table==gerParamTable )
    }
        return (<> <div className="mt-3">
                <div className="grid crud-demo">
                    <div className="col-12">
                        <div className="card">
                        {(gerParam==null)?(<>
                                <GNama 
                                {...this.props} 
                                hide={ () => this.setState({visibleRight:false}) }
                                putSaveCodeProp={putSaveCode}
                                refreshData={this.initData}
                                linkValidatePermitions={this.state.validatePermitions}
                                />
                                <GNamaCultive
                                    {...this.props}
                                    info_select={{ name: 'Información Cultivo', table: 'info_crops_g' }}
                                    putSaveCodeProp={putSaveCode}
                                    codeSave={this.state.codeSave}
                                    refreshData={this.initData}
                                    validatePermitions={changeValidate}
                                />
                                </>):(<>
                                {(selectedOptions==undefined)?(null):(<>
                                        <selectedOptions.componentInit
                                            {...this.props}
                                            //location={useLocation()}
                                            info_select={selectedOptions}
                                            hide={ () => {this.setState({visibleRight:false})} }
                                            //sendInfoProps={[]}
                                            refreshData={this.initData}
                                            setParamsUrl={window.location} 
                                            tableCall={selectedOptions.table} 
                                            titleCall={selectedOptions.name} 
                                        />
                                    </>)}

                                </>)}
                        <br />
                        <br />
                        <br />
                        </div>
                    </div>
                </div>
            </div>

            </>)
    }
}